export default __webpack_public_path__ + "20f6b741c7fa785a8ac66ae4f7e78325.svg";